import React from 'react'
import { Modal } from '@mui/material'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'

const BoxModal = (props: any) => {
  const {
    show,
    handleClose,
    head,
    description,
    primaryEventContent,
    primaryEventClick,
    secondaryEventContent,
    secondaryEventClick,
  } = props
  return (
    <Modal
      open={show}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div className="add-folder">
        <h4>{head}</h4>
        <h5 className="mt-5 mb-5">{description}</h5>
        <div className="d-flex justify-content-center">
          {primaryEventContent && (
            <Button
              variant="outlined"
              size="small"
              color="primary"
              className="m-3"
              onClick={primaryEventClick}
            >
              {primaryEventContent}
            </Button>
          )}
          {secondaryEventContent && (
            <Button
              variant="contained"
              size="small"
              color="primary"
              className="m-3"
              onClick={secondaryEventClick}
            >
              {secondaryEventContent}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  )
}

BoxModal.propTypes = {
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  head: PropTypes.string,
  description: PropTypes.string,
  primaryEventContent: PropTypes.string,
  primaryEventClick: PropTypes.func,
  secondaryEventContent: PropTypes.string,
  secondaryEventClick: PropTypes.func,
}

export default BoxModal
